import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./LUTRegistration.css";
import "../PrivateLimitedCompany.css"

const LUTRegistration = () => {

 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }



  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>LUT Certificate Registration</h1>

        <p className="subtitle">
          Export Without Paying GST Easily
        </p>

        <p className="desc">
          A Letter of Undertaking (LUT) allows exporters to supply goods or services without paying IGST under GST. We help you file LUT quickly and correctly so you can improve cash flow and grow your export business.
        </p>

        <div className="badges">
          <span>✔ 100% Online Filing</span>
          <span>✔ Quick Approval Process</span>
          <span>✔ Expert GST Support</span>
          <span>✔ Hassle-Free Compliance</span>
        </div>

       <div className="hero-action">
                    <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
                </div>


      </div>

      {/* WHAT IS LUT */}
      <div className="section">
        <h2>What is LUT (Letter of Undertaking)?</h2>
        <p>
          The LUT is a declaration filed under GST that allows exporters to export goods or services without paying Integrated GST (IGST). It is filed with the GST department annually.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of LUT Certificate</h2>
        <ul>
          <li>Export without paying IGST</li>
          <li>Improves cash flow</li>
          <li>No tax refund delays</li>
          <li>Easy online filing</li>
          <li>Valid for one financial year</li>
          <li>Essential for regular exporters</li>
        </ul>
      </div>

      {/* WHO CAN APPLY */}
      <div className="section">
        <h2>Who Can Apply for LUT?</h2>
        <ul>
          <li>Exporters of goods</li>
          <li>Exporters of services</li>
          <li>E-commerce exporters</li>
          <li>Freelancers (eligible cases)</li>
          <li>International trade businesses</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>
        <ul>
          <li>GST Registration Certificate</li>
          <li>PAN Card</li>
          <li>Authorized Signatory Details</li>
          <li>Business Address Proof</li>
          <li>Previous export details (if applicable)</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>LUT Filing Process</h2>
        <ul>
          <li>Consultation – Check eligibility</li>
          <li>Document Collection</li>
          <li>Online Filing on GST Portal</li>
          <li>Verification by GST Department</li>
          <li>LUT Approval Issued</li>
        </ul>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Fast LUT Filing Service</li>
          <li>GST Experts Handling Your Case</li>
          <li>Error-Free Documentation</li>
          <li>Affordable Pricing</li>
          <li>End-to-End Support</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Is LUT mandatory?</b> No, but required to export without IGST.</p>
        <p><b>Validity?</b> Valid for one financial year.</p>
        <p><b>Can it be filed online?</b> Yes, via GST portal.</p>
        <p><b>Without LUT?</b> You must pay IGST and claim refund later.</p>

      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>File Your LUT Today</h2>
        <p>Export freely without blocking your funds in taxes.</p>

           <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
      </div>

    </div>
  );
};

export default LUTRegistration;